import { render } from "./ResetFlow.vue?vue&type=template&id=4a4cc436&scoped=true&ts=true"
import script from "./ResetFlow.vue?vue&type=script&lang=ts"
export * from "./ResetFlow.vue?vue&type=script&lang=ts"

import "./ResetFlow.vue?vue&type=style&index=0&id=4a4cc436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4cc436"]])

export default __exports__